import { render, staticRenderFns } from "./ProductQuestions.vue?vue&type=template&id=cff0e27c&"
import script from "./ProductQuestions.vue?vue&type=script&lang=js&"
export * from "./ProductQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports